export default "__VITE_ASSET__j6DzfAXW__"